<template>
    <div>
        <div class="update-threshold">
            <div class="label">設定人数</div>
            <div class="form"><el-input-number v-model="num" :min="1" :max="1000" /></div>
        </div>
        <div class="update-threshold">
            <div class="label">メール通知</div>
            <div class="form switch"><el-switch v-model="isSendMail" active-text="オン" inactive-text="オフ" /></div>
        </div>
        <div class="update-threshold">
            <div class="label">超過時間(分)<el-popover width="200" trigger="click" content="カメラ内の人数が設定人数を超過してから、連続で何分間超えた場合に通知されるかを設定します。"><i class="el-icon-question" slot="reference" /></el-popover></div>
            <div class="form"><el-input-number v-model="exccessCountLimit" :min="1" :max="30" :disabled="!isSendMail" /></div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        streamData: {
            type: Object,
            default: () => {},
            required: false
        }
    },
    data() {
        return {
            value: this.streamData.threshold,
            countLimit: this.streamData.excessCountLimit,
            sendFlg: false,
            confObject: {}
        }
    },
    computed: {
        // 設定人数
        num: {
            get() {
                return this.value;
            },
            set(value) {
                this.value = value
                this.$set(this.confObject, "thresholdNumber", value)
            }
        },
        // 通知条件（連続上限超過回数）
        exccessCountLimit: {
            get() {
                return this.countLimit
            }, 
            set(value) {
                this.countLimit = value
                this.$set(this.confObject, "exccessCountLimit", value)
            }
        },
        // メール送信要否
        isSendMail: {
            get() {
                return this.sendFlg
            },
            set(value) {
                this.sendFlg = value
                this.$set(this.confObject, "sendMailFlag", String(value))
            }
        }
    },
    watch: {
        confObject: {
            handler: function (obj) {
                this.$set(this.$store.state.configurationData, this.streamData.stream_id, obj)
            },
            deep: true
        },
    },
    mounted() {
        let sendFlg = false
        if (this.streamData.sendMailFlag) {
            sendFlg = true
        }
        this.sendFlg = sendFlg
        this.$set(this.confObject, "sendMailFlag", String(sendFlg))
    }
}
</script>

<style scoped>
    .update-threshold{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
    
    .form{
        margin: 0 130px 0 auto;
    }
    
    .form.switch{
        margin: 0 160px 0 auto;
    }
    
    .label{
        margin: 0 auto 0 40px;
        width: auto;
    }
    
    .el-icon-question{
        padding-left: 10px;
        color: #00AA00;
    }
    
    @media screen and (max-width: 980px) {
 
        .label{
            margin: 0 auto 0 15px;
        }
        
        .form{
            margin: 0 30px 0 auto;
        }
        
        .form.switch {
            margin: 0 30px 0 auto;
        }
        
        .el-input-number {
            width: 130px;
            line-height: 26px;
        }
        
        .el-input-number >>> .el-input-number__increase{
            width: 28px;
            font-size: 12px;
        }
        
        .el-input-number >>> .el-input-number__decrease {
            width: 28px;
            font-size: 12px;
        }
        
        .el-input-number >>> input.el-input__inner{
            height: 28px;
            line-height: 28px;
            padding-left: 35px;
            padding-right: 35px;
        }
    }
</style>